import store from '../store'
let formatter = null


create()

store.subscribe((mutation) => {
  if(mutation.type !== 'setCurrentLocale') return
  create()
})

export default  function (value) {
  let valueNew = parseFloat(value)
  if(!formatter || !valueNew) return value

  return formatter.format(valueNew)
}

// - - - -

function create() {
  if(!store.state.currentLocale) return
  let name = store.state.locales[store.state.currentLocale].regional

  if(!name) return;
  name = name.replace('_', '-')

  formatter = new Intl.NumberFormat(name, {
    maximumFractionDigits: 2
  });
}
